module.exports = __webpack_public_path__ + "img/cons.75c08396.jpg";